exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title[data-v-f83d727a]{color:#262626;font-weight:500;font-size:18px;line-height:26px}.label[data-v-f83d727a]{color:#8c8c8c;font-weight:400;font-size:14px;line-height:22px}.info[data-v-f83d727a]{color:#595959;font-weight:400;font-size:14px;line-height:22px;white-space:pre-wrap;word-break:break-all}\n", ""]);

